import { Box, Flex, type FlexProps } from '@chakra-ui/react';
import type { ReactNode } from 'react';
import type { DashboardBulkSelection } from './dashboardBulkSelection';
import {
    DASHBOARD_RO_COLUMN_PL_CSS,
    getBulkCheckboxLeft,
    HOME_CONTENT_PL_WITH_BULK,
    RO_BULK_CHECKBOX_GUTTER,
} from '../../constants/pageLayout';
import OrderRoColumnCheckboxSlot from './OrderRoColumnCheckboxSlot';

interface HomeRoColumnRowProps extends FlexProps {
    checkbox: ReactNode;
    status: ReactNode;
    children: ReactNode;
}

/** Main layout: status icon then RO text; checkbox centered in the left gutter. */
export const HomeRoColumnRow = ({ checkbox, status, children, ...flexProps }: HomeRoColumnRowProps) => (
    <>
        <Box
            position="absolute"
            left={getBulkCheckboxLeft(HOME_CONTENT_PL_WITH_BULK)}
            top="50%"
            transform="translateY(-50%)"
            w={RO_BULK_CHECKBOX_GUTTER}
            display="flex"
            alignItems="center"
            justifyContent="center"
            onClick={(e) => e.stopPropagation()}
        >
            {checkbox}
        </Box>
        <Flex align="center" gap={2} {...flexProps}>
            {status}
            {children}
        </Flex>
    </>
);

interface DashboardRoColumnRowProps extends FlexProps {
    bulkSelection?: DashboardBulkSelection;
    orderId: string;
    rowIndex: number;
    isChecked: boolean;
    children: ReactNode;
}

export const DashboardRoColumnRow = ({
    bulkSelection,
    orderId,
    rowIndex,
    isChecked,
    children,
    ...flexProps
}: DashboardRoColumnRowProps) => {
    if (!bulkSelection?.enabled) {
        return (
            <Flex align="center" gap={2} minW={0} {...flexProps}>
                {children}
            </Flex>
        );
    }

    return (
        <>
            <Box
                position="absolute"
                left={getBulkCheckboxLeft(DASHBOARD_RO_COLUMN_PL_CSS)}
                top="50%"
                transform="translateY(-50%)"
                w={RO_BULK_CHECKBOX_GUTTER}
                display="flex"
                alignItems="center"
                justifyContent="center"
                onClick={(e) => e.stopPropagation()}
            >
                <OrderRoColumnCheckboxSlot
                    orderId={orderId}
                    rowIndex={rowIndex}
                    isChecked={isChecked}
                    onToggle={bulkSelection.onToggle}
                />
            </Box>
            <Flex align="center" gap={2} minW={0} {...flexProps}>
                {children}
            </Flex>
        </>
    );
};
